import React, { FC } from "react"
import { useSelector } from "react-redux";
import {IState} from "../../../../../types/state";
import CustomIndicator from "./CustomIndicator";
import CustomFailPanel from "./CustomFailPanel";
import {TranslationsType} from "../../../../../types/homePageTypes";
import {ICurrencies} from "../../MainLayout";
import cls from "../customHeader.module.scss"
import CustomIndicatorCart from "./CustomIndicatorCart";

interface IIndicatorPanel {
    translationsData: TranslationsType;
    selectedLocale: string;
    selectedRate: ICurrencies;
    showWishlist: boolean
    dbName: string;
    showCart: boolean;
    allowCheckoutValue: string;
}

const CustomIndicatorPanel: FC<IIndicatorPanel> = (
    {
        translationsData,
        selectedLocale,
        selectedRate,
        dbName,
        showWishlist,
        showCart,
        allowCheckoutValue
    }
) => {
    if (!showWishlist && !showCart) return <></>;

    const signed = useSelector((state: IState) => state.customer.authenticated);
    const wishlist = useSelector((state: IState) => state.wishlist);
    const wishIndicator = {
        "true": {
            "true": <CustomIndicator
                url="/wishlist"
                value={wishlist.length}
                icon="heartIcon"
                title={translationsData?.WishList}
                className=""
                dropdown=""
                iconWrapperClassName=""
            />,
            "false": <CustomFailPanel translationsData={translationsData}/>
        },
        "false": {
            "true": null,
            "false": null
        }
    }

    const hasCart = {
        "true": <div className={`${cls["nav-panel__item_row"]}`}>
            <CustomIndicatorCart
                allowCheckoutValue={allowCheckoutValue}
                translationsData={translationsData}
                dbName={dbName}
                selectedRate={selectedRate}
                locale={selectedLocale}
            />
        </div>,
        "false": null
    }

    return (
        <div className={`${cls["nav-panel__row"]}`}>
            <div className={`${cls["nav-panel__indicators"]}`}>
                <div className={`${cls["nav-panel__item_row"]} ${cls.heartButton}`}>
                    {wishIndicator[`${showWishlist}`][`${signed}`]}
                </div>
                {hasCart[`${showCart}`]}
            </div>
        </div>
    )
};

export default CustomIndicatorPanel;